export enum PersonPersonTypeEnum {
  "Syndic" = 0,
  "ACP_VME" = 1,
  "Concierge" = 2,
  "Owner" = 3,
  "Occupant" = 4,
  "Present_During_Visit" = 5,
}
